<div  class="new-business-unification-root" *transloco="let t">

  <div class="business-unification-title">
    {{ 'new-business-unification' | transloco}}
  </div>

  <div class="business-unification-subtitle">
    {{ 'new-business-unification-subtitle' | transloco}}
  </div>

  <div class="business-unification-forms" *ngIf="this.countries.length > 0">
    
    <div class="business-unification-line">
      <div class="business-unification-field-label">
        {{ 'country' | transloco}}
      </div>
      <app-country-selector
        *ngIf="countries?.length"
        class="country-selector"
        [countries]="countries"
        [isMultiSelect]="false"
        (valueChange)="onCountryFilterChanged($event)">
      </app-country-selector>
    </div>

    <div class="business-unification-line" *ngIf="this.businessList.length > 0">
      <div class="business-unification-field-label">
        {{ 'businesses-to-unify' | transloco}}
      </div>
      <div>
        <app-multi-select
          [options]="businessList"
          [isMultiselector]="true"
          [placeholder]="'Select businesses to merge'"
          [entity]="'business'"
          (valueChange)="handleChangeOrigin($event)"
        ></app-multi-select>
      </div>
    </div>

    <div class="business-unification-line business-destination-line" *ngIf="this.selectedBusinessOrigins.length > 0">
      <div class="business-destination-icon">
        <mat-icon>
          subdirectory_arrow_right
        </mat-icon>
      </div>
      <div class="business-destination-input">
        <div class="business-unification-field-label">
          {{ 'destination-business' | transloco}}
        </div>
        <div>
          <app-multi-select
            [options]="selectedBusinessOrigins"
            [isMultiselector]="false"
            [placeholder]="'Select destination business'"
            [entity]="'business'"
            (valueChange)="handleChangeDestination($event)"
          ></app-multi-select>
        </div>
      </div>
      
    </div>

  </div>

  <div class="business-unification-actions">
    <div class="action-cancel">
      <app-primary-button stroked [disabled]="loading"
                          (clickAction)="onCloseClick()">
        {{t('cancel')}}
      </app-primary-button>
    </div>
    <div class="action-confirm">
      <app-primary-button [disabled]="loading || !isFormValid()"
                          (clickAction)="createBusinessUnification()">
        {{t('confirm')}}
      </app-primary-button>
    </div>

  </div>

</div>
